export const MAX_LAT = 90;
export const MIN_LAT = -90;
export const MIN_LNG = -180;
export const MAX_LNG = 180;
